<!-- KPI row -->
<div class="emd-kpi-row mb-3">
  <emd-kpi-card *ngFor="let card of kpiCards" [kpi]="card" class="emd-kpi-slot"></emd-kpi-card>
</div>

<!-- Dispense and Inventory Balance -->
<div class="emd-card mb-3">
  <emd-widget-header
    title="Dispense and Inventory Balance"
    selectionOrigin="inventory-balance"
    infoText="Days on hand (bars) against on-hand and sold quantities (lines) from the 852 inventory feed. Click a legend entry to hide its series; click bars to stage a period selection."
  ></emd-widget-header>

  <!-- The chart draws its own clickable legend (DOH bars + the two qty lines). -->
  <div class="emd-balance-host">
    <emd-bar-line-trend-chart
      [barData]="balanceBarData"
      [barLabel]="'DOH'"
      [barColor]="balanceBarColor"
      [lineData]="balanceLineData"
      [lineColors]="balanceLineColors"
      [leftAxisLabel]="'QTY'"
      [rightAxisLabel]="'DOH'"
      [dateFormat]="'D'"
      [chartHeight]="468"
      [selectedPeriods]="selectedPeriods"
      (barClick)="onBalanceBarClick($event)"
    ></emd-bar-line-trend-chart>
  </div>
</div>

<!-- Trend grid + DOH (AVG) bar chart -->
<div class="row g-3">
  <div class="col-xl-8">
    <div class="emd-card h-100">
      <emd-widget-header
        title="Trend"
        selectionOrigin="inventory-grid"
        [csv]="true"
        (csvExport)="inventoryGrid.exportCsv('inventory-trend')"
        infoText="Weekly QTY On Hand per wholesaler, with per-location drill-down. The chart on the right shows the latest week's snapshot."
      >
        <label class="emd-search">
          <mat-icon>search</mat-icon>
          <input
            type="text"
            placeholder="Search..."
            [ngModel]="searchText"
            (ngModelChange)="onSearch($event)"
          />
        </label>
        <label class="emd-metric-select">
          <span class="emd-metric-label">Metric:</span>
          <select [(ngModel)]="selectedMetric">
            <option *ngFor="let m of metrics" [value]="m">{{ m }}</option>
          </select>
        </label>
      </emd-widget-header>

      <div class="emd-grid-host">
        <emd-hierarchical-grid
          #inventoryGrid
          [rowData]="inventoryRows"
          [columnDefs]="inventoryColumnDefs"
          [childColumnDefs]="inventoryChildColumnDefs"
          [grandTotal]="true"
          [height]="380"
          [selected]="selectedWholesalers"
          (rowSelect)="onRowSelect($event)"
        ></emd-hierarchical-grid>
      </div>
    </div>
  </div>

  <div class="col-xl-4">
    <div class="emd-card h-100">
      <emd-widget-header
        title="QTY On Hand"
        [subtitle]="dohLatestDate"
        infoText="Each wholesaler's QTY On Hand at the latest week shown in the Trend grid (its rightmost column), highest first."
      ></emd-widget-header>
      <div class="emd-canvas-wrap emd-doh-canvas">
        <canvas #dohChart></canvas>
      </div>
    </div>
  </div>
</div>
